const TabButtonGroup = ({ children, injectClass }) => {
    return (
        <div className={`bg-bluegray-300 dark:bg-ddark inline-block py-1 rounded-lg ${injectClass}`}>
            {children}
        </div>
    )
}

export default TabButtonGroup